import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@artosera/ui';
import { TONE_ETAT_OUVERTURE } from '../../lib/ouvertures.js';
import type { EtatOuverture } from '../../types.js';

/** L'état d'un dossier, tel que l'API le rend. */
export function BadgeEtatOuverture({ etat }: { etat: EtatOuverture }): JSX.Element {
  const { t } = useTranslation('console');
  return <Badge tone={TONE_ETAT_OUVERTURE[etat]}>{t(`ouvertures.etat.${etat}`)}</Badge>;
}
